import { ParsedUrlQuery } from 'querystring';

export function getIsStudentAccommodation(query: ParsedUrlQuery) {
    if (query['is_student_accommodation']) {
        return query['is_student_accommodation'];
    }

    return '';
}
